import React from "react";

import Modal from "@components/modal/main-modal";
import Spinner from "@components/spinner/spinner";

type Props = {
  children?: React.ReactNode;
  isLoading?: boolean;
  isError?: boolean;
  errorMessage?: any;
};

function QueryHandler({ children, isLoading, isError, errorMessage }: Props) {
  if (isLoading) {
    return <Spinner />;
  }
  if (isError) {
    return (
      <Modal>
        <div className='flex items-center justify-center'>
          <p>
            {errorMessage && errorMessage.data.error
              ? errorMessage.data.error
              : "Сталася помилка"}
          </p>
        </div>
      </Modal>
    );
  }

  // eslint-disable-next-line
  return <>{children}</>;
}

export default QueryHandler;
